/**
 * StyledChannelViewContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled channel view container.
 */
const StyledChannelViewContainer = styled.div`
  float: left;
  width: ${677 * Screen.widthRatio}px;
  // margin-right: ${67 * Screen.widthRatio}px};
  // margin-top: ${55 * Screen.heightRatio}px;
  text-align: center;
`;

export default StyledChannelViewContainer;
